// extracted by mini-css-extract-plugin
module.exports = {"skeletonLoader":"configuration-flow-module-list_skeletonLoader__D1__t"};